/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../Icon';

/**
 * @deprecated since version 20.2.0. Please use the new Glyph component. You can read more about it in the prisma-design-system storybook under iconography/glyphs.
 */
const ArrowDouble: any = ({ color, size = 'medium', ...props }) => {
  return (
    // @ts-expect-error TODO: Fix viewBox type in next ticket OF2-3365
    <Icon viewBox="0 0 24 24" size={size} color={color} {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.95 5.295a.997.997 0 011.414 0l.085.086a.999.999 0 010 1.414l-3.863 3.863h12.777L14.5 6.795a.999.999 0 010-1.414l.086-.086a.998.998 0 011.414 0l5.656 5.656a.999.999 0 010 1.414L16 18.021a.999.999 0 01-1.414 0l-.086-.085a.999.999 0 010-1.415l3.863-3.863H5.586l3.864 3.864a.999.999 0 010 1.414l-.086.085a.999.999 0 01-1.415 0l-5.656-5.656a.999.999 0 010-1.414L7.95 5.295z"
      />
    </Icon>
  );
};

export default ArrowDouble;

ArrowDouble.propTypes = {
  color: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};
